<template>
    <div>
        <div class="top-panel">
            <div class="left-box">
                <img :src="user.avatar"/>
            </div>
            <div class="center-box">
                <div class="name">{{user.nick_name}}</div>
                <div class="grade">{{welcome}}</div>
            </div>
        </div>
<!--暂时隐藏，后期启用-->
<!--        <div class="order-panel" v-if="mode==1&&!user.member_level">-->
<!--            <van-cell-group>-->
<!--                <van-cell title="申领会员卡" icon="idcard" is-link @click="applyMember" />-->
<!--            </van-cell-group>-->
<!--        </div>-->
<!--        <div v-if="mode==1&&user.member_level>=1" class="member-card">-->
<!--            <van-row>-->
<!--                <van-col span="4">-->
<!--                    <div class="icon-box"><van-icon class="icon" name="medal-o" /></div>-->
<!--                </van-col>-->
<!--                <van-col span="8">-->
<!--                    <div class="text-box">-->
<!--                        <div class="title">梅唐四季会员卡</div>-->
<!--                        <div class="sub-title">会员等级：普通</div>-->
<!--                    </div>-->
<!--                </van-col>-->
<!--            </van-row>-->
<!--        </div>-->

        <div class="order-panel">
            <van-cell-group>
<!--                <van-cell title="草莓雨奖品" icon="star-o" is-link @click="myRewards" v-if="mode==1"/>-->
                <van-cell title="我的优惠券" icon="coupon-o" is-link @click="myCoupons" v-if="mode==1"/>
                <!--                <van-cell title="提现申请" icon="gold-coin-o" is-link @click="cashApply" v-if="mode==2" />-->
                <!--                <van-cell title="提现记录" icon="notes-o" is-link v-if="mode==2" />-->
                <!--                <van-cell title="推广数据" icon="chart-trending-o" is-link v-if="mode==2" />-->
                <!--                <van-cell title="关于耘径联盟" icon="cluster-o" is-link  v-if="mode==2"/>-->
                <!--                <van-cell title="关于梅唐四季" icon="home-o" is-link />-->
            </van-cell-group>
        </div>

        <div class="agent-panel" v-if="mode==2">
            <van-grid :border="false">
                <van-grid-item>
                    <div class="label">待入账</div>
                    <div class="val">{{agentData.val20}}</div>
                </van-grid-item>
                <van-grid-item>
                    <div class="label">可提现</div>
                    <div class="val">{{agentData.val30}}</div>
                </van-grid-item>
                <van-grid-item>
                    <div class="label">提现中</div>
                    <div class="val">{{agentData.val40}}</div>
                </van-grid-item>
                <van-grid-item>
                    <div class="label">已提现</div>
                    <div class="val">{{agentData.val50}}</div>
                </van-grid-item>
            </van-grid>
        </div>

        <div class="order-panel" v-if="mode==1">
            <div class="title-banner">
                <span class="title">我的电子票</span>
<!--                <div class="right-label">-->
<!--                    <span>查看全部</span>-->
<!--                    <van-icon class="icon" size="14" name="arrow" />-->
<!--                </div>-->
            </div>
            <van-grid :column-num="2" :border="false">
                <van-grid-item icon="qr" text="待使用" @click="showTicket(0)" />
                <van-grid-item icon="qr-invalid" text="已核销" @click="showTicket(1)" />
            </van-grid>
        </div>

        <div class="order-panel" v-if="mode==1">
            <div class="title-banner">
                <span class="title">我的订单</span>
                <div class="right-label" @click="goOrderListClient(0)">
                    <span>查看全部</span>
                    <van-icon class="icon" size="14" name="arrow" />
                </div>
            </div>
            <van-grid :border="false">
                <van-grid-item icon="cashier-o" text="待支付" @click="goOrderListClient(1)" />
                <van-grid-item icon="clock-o" text="待发货" @click="goOrderListClient(2)" />
                <van-grid-item icon="logistics" text="已完成" @click="goOrderListClient(3)"/>
                <van-grid-item icon="refund-o" text="退款/售后" />
            </van-grid>
        </div>

        <div class="order-panel" v-if="mode==2">
            <div class="title-banner">
                <span class="title">我的订单</span>
                <div class="right-label" @click="goOrderListAgent(0)">
                    <span>查看全部</span>
                    <van-icon class="icon" size="14" name="arrow" />
                </div>
            </div>
            <van-grid :column-num="3" :border="false">
                <van-grid-item icon="underway-o" text="待入账" @click="goOrderListAgent(1)" />
                <van-grid-item icon="balance-o" text="可提现" @click="goOrderListAgent(2)" />
                <van-grid-item icon="refund-o" text="退款/售后" />
            </van-grid>
        </div>

        <div class="order-panel">
            <van-cell title="客服" icon="service-o" is-link @click="showCS" />
        </div>

        <div style="padding: 40px">&nbsp;</div>
        <partner-footer p_active="2" />
    </div>
</template>

<script>
    import config from '@/config';
    import PartnerFooter from "../../components/Footer/PartnerFooter";
    import { mapActions } from 'vuex';
    import store from '@/store';

    export default {
        name: "Account",
        components: {PartnerFooter},
        data(){
            return{
                user:this.$store.getters.getLoginUser,
                mode:config.mode,   //1梅唐四季，2耘径联盟
                cs:{},  //客服资料
                agentData:{},   //代理佣金数据
                welcome:config.mode==1?'梅唐四季':'耘径联盟',
            }
        },
        methods:{
            ...mapActions([
                'GetAppCSInfo',
                'GetAgentStatisticData',
                'ApplyMember'
            ]),
            cashApply(){
                this.$router.push({name:'CashApply'});
            },
            goOrderListAgent(status){
                this.$router.push({name:'MyOrderAgent',params:{status}});
            },
            goOrderListClient(status){
                this.$router.push({name:'MyOrderClient',params:{status}});
            },
            loadCSInfo(){
                let mode=this.mode;
                this.GetAppCSInfo({mode}).then(res=>{
                    this.cs=res;
                })
            },
            showCS(){
                this.$imagePreview([this.cs.avatar]);
            },
            showTicket(val){
                this.$router.push({name:'MyTicket',params:{active:val}});
            },
            myCoupons(){
                this.$router.push({name:'MyCoupons'});
            },
            myRewards(){
                this.$router.push({name:'MyRewards'});
            },
            loadAgentData(){
                let uid=this.user.id;
                this.GetAgentStatisticData({uid}).then(res=>{
                    this.agentData=res;
                });
            },
            applyMember(){
                //申请会员
                let uid=this.user.id;
                this.ApplyMember({uid}).then(res=>{
                    if(res.status>0){
                        this.$toast.fail('会员卡领取失败!');
                    }else{
                        //成功,更新本地用户缓存数据
                        this.user = res.responseObject;
                        this.$store.commit('setUser',this.user);
                    }
                });
            }
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            // console.log(this.user);
            this.loadCSInfo();
            if(this.mode==2){
                //代理商模式下才取数据
                this.loadAgentData();
            }
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            // console.log('login user',loginUser);
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid=to.params.sales_uid;
                let mode=1; //梅唐四季模式
                // console.log('微信code值',code);
                // console.log('渠道号值',sales_uid);
                if(code){
                    // console.log('----- 开始调用后台微信登录接口 ------');
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        // console.log('返回对象',res);
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state=''; //'product-detail-sale/1004/1002'; //debug
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    // console.log('weixin auth url',auth_url);
                    window.location.href = auth_url;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .top-panel{
        background-color: #FFFFFF;
        margin: 14px 4px;
        min-height: 80px;
        /*border-radius: 10px;*/
        .left-box{
            display: inline-block;
            line-height: 80px;
            float: left;
            min-width: 70px;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                vertical-align: middle;
            }
        }
        .center-box{
            display: inline-block;
            width: 70%;
            min-height: 80px;
            text-align: left;
            float: left;
            .name{
                padding-top: 20px;
                font-size: 16px;
                color: #333333;
            }
            .grade{
                padding-top: 4px;
                font-size: 12px;
                color: #666666;
            }
        }
    }
    .agent-panel{
        background-color: #FFFFFF;
        margin: 14px 4px;
        /*border-radius: 10px;*/
        .label{
            font-size: 14px;
        }
        .val{
            font-size: 12px;
            padding-top: 6px;
        }
    }
    .title-banner{
        padding: 5px;
        text-align: left;
        line-height: 30px;
        .title{
            font-size: 14px;
            color: #666666;
            font-weight: bold;
        }
        .right-label{
            font-size: 12px;
            color: #999999;
            float: right;
            .icon{
                vertical-align: middle;
                padding-bottom: 4px;
            }
        }
    }
    .order-panel{
        background-color: #FFFFFF;
        margin: 14px 4px;
        border-radius: 10px;
        text-align: left;
        /*padding: 5px;*/
    }

    .member-card{
        background-color: #E8D9B2;
        margin: 14px 4px;
        border-radius: 10px;
        min-height: 150px;
        .icon-box{
            font-size: 28px;
            color: #666666;
            padding-top: 20px;
        }
        .text-box{
            padding-top: 10px;
            text-align: left;
            .title{
                font-size: 16px;
                color: #323334;
            }
            .sub-title{
                padding-top: 4px;
                font-size: 12px;
                color: #666666;
            }
        }

    }
</style>
